<div class="container" style="background-color: var(--surface-overlay);
border-radius: 36px;
box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
">
  <div class="header flex justify-content-between align-items-center">
    <h1>Manage Drivers</h1>
    <div class="flex gap-2">
      <p-button label="Select All Drivers" icon="pi pi-check-circle" styleClass="p-button-raised"
        (onClick)="selectAllDrivers()"></p-button>
      <p-button label="Deselect All Drivers" icon="pi pi-times-circle" styleClass="p-button-outlined p-button-raised"
        (onClick)="deselectAllDrivers()"></p-button>
    </div>
  </div>

  <!-- Driver Sections -->
  <p-scrollPanel class="p-0.5" [style]="{ width: '100%', height: 'calc(100vh - 250px)' }">
    
    <!-- Driver Type Sections -->
    <div *ngFor="let driverType of driverTypes" class="driver-type-section" [ngClass]="driverType.className" 
         [style.display]="driverType.drivers.length > 0 ? '' : 'none'">
      <div class="section-header">
        <h2>{{driverType.type}} Drivers</h2>
        <div class="section-actions">
          <p-button label="Select All" icon="pi pi-check" 
                    styleClass="p-button-sm" (onClick)="selectAllDriversByType(driverType.type)"></p-button>
          <p-button label="Deselect All" icon="pi pi-times" 
                    styleClass="p-button-sm p-button-outlined" (onClick)="deselectAllDriversByType(driverType.type)"></p-button>
        </div>
      </div>
      
      <div class="driver-grid">
        <div *ngFor="let driver of driverType.drivers" (click)="toggleDriver(driver)"
             class="driver-card" [ngClass]="{'selected': driver.selected}">
          <div class="driver-info">
            <span>{{driver.first_name}} {{driver.last_name}}</span>
          </div>
          <p-checkbox [(ngModel)]="driver.selected"
                     styleClass="p-checkbox-sm"
                     [binary]="true"></p-checkbox>
        </div>
      </div>
    </div>
  </p-scrollPanel>

  <p-toast position="bottom-right"></p-toast>